export default __webpack_public_path__ + "static/media/safekey.f403149d.svg";